import _classCallCheck from 'babel-runtime/helpers/classCallCheck';
export var InitResult = function InitResult() {
    _classCallCheck(this, InitResult);

    this.status = false;
    this.rawData = '';
};
var errorMsg = [{
    errCode: '1',
    errMsg: '内存不足',
    retCode: '290001'
}, {
    errCode: '2',
    errMsg: '参数错误',
    retCode: '290002'
}, {
    errCode: '3',
    errMsg: '配置错误',
    retCode: '290003'
}, {
    errCode: '4',
    errMsg: '执行功能时云端服务异常',
    retCode: '290004'
}, {
    errCode: '5',
    errMsg: '打开文件失败',
    retCode: '290005'
}, {
    errCode: '6',
    errMsg: '读取文件失败',
    retCode: '290006'
}, {
    errCode: '7',
    errMsg: '写入文件失败',
    retCode: '290007'
}, {
    errCode: '8',
    errMsg: 'SDK未初始化',
    retCode: '290008'
}, {
    errCode: '9',
    errMsg: 'SDK重复初始化',
    retCode: '290009'
}, {
    errCode: '10',
    errMsg: '执行功能时网络连接异常',
    retCode: '290010'
}, {
    errCode: '11',
    errMsg: '模块还没有处理结果',
    retCode: '290011'
}, {
    errCode: '12',
    errMsg: 'TTS模块输出结果失败（继承IFilter的输出过滤器）',
    retCode: '290012'
}, {
    errCode: '13',
    errMsg: 'SDK调用通用错误',
    retCode: '290013'
}, {
    errCode: '100',
    errMsg: 'ASR模块调用失败',
    retCode: '290100'
}, {
    errCode: '101',
    errMsg: 'ASR模块已经在工作中',
    retCode: '290101'
}, {
    errCode: '102',
    errMsg: 'ASR模块没有语音输入',
    retCode: '290102'
}, {
    errCode: '103',
    errMsg: 'ASR模块还未开始工作',
    retCode: '290103'
}, {
    errCode: '104',
    errMsg: 'ASR模块没有识别结果',
    retCode: '290104'
}, {
    errCode: '200',
    errMsg: 'NLU模块调用失败',
    retCode: '290200'
}, {
    errCode: '300',
    errMsg: 'TTS模块调用失败',
    retCode: '290300'
}, {
    errCode: '301',
    errMsg: 'TTS模块已经在工作中',
    retCode: '290301'
}, {
    errCode: '302',
    errMsg: 'TTS模块没有输入',
    retCode: '290302'
}, {
    errCode: '303',
    errMsg: 'TTS模块输出结果失败（继承IFilter的输出过滤器）',
    retCode: '290303'
}, {
    errCode: '304',
    errMsg: 'TTS模块不在工作状态',
    retCode: '290304'
}, {
    errCode: '305',
    errMsg: 'TTS模块语音合成失败',
    retCode: '290305'
}, {
    errCode: '400',
    errMsg: '保留',
    retCode: '290400'
}];
export function errorJudge(errCode) {
    var normal = {
        errCode: '',
        errMsg: '未知错误',
        retCode: '290999'
    };
    var errorObj = errorMsg.filter(function (item) {
        return item.errCode === errCode.toString();
    });
    return errorObj.length > 0 ? errorObj[0] : normal;
}